"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable max-len */
var react_1 = __importDefault(require("react"));
var GitMerge = function (_a) {
    var size = _a.size, title = _a.title, color = _a.color, svgProps = __rest(_a, ["size", "title", "color"]);
    return (react_1.default.createElement("svg", __assign({ stroke: "currentcolor", fill: "currentColor", strokeWidth: "0" }, svgProps, { width: size || '1rem', height: size || '1rem', viewBox: "0 0 24 24", style: __assign({ color: color }, svgProps.style), xmlns: "http://www.w3.org/2000/svg" }),
        title && react_1.default.createElement("title", null, title),
        react_1.default.createElement("g", { id: "git-merge" },
            react_1.default.createElement("path", { id: "Icon", d: "M5 21C5 21.5523 5.44772 22 6 22C6.55228 22 7 21.5523 7 21H5ZM20 18C20 19.1046 19.1046 20 18 20V22C20.2091 22 22 20.2091 22 18H20ZM18 20C16.8954 20 16 19.1046 16 18H14C14 20.2091 15.7909 22 18 22V20ZM16 18C16 16.8954 16.8954 16 18 16V14C15.7909 14 14 15.7909 14 18H16ZM18 16C19.1046 16 20 16.8954 20 18H22C22 15.7909 20.2091 14 18 14V16ZM8 6C8 7.10457 7.10457 8 6 8V10C8.20914 10 10 8.20914 10 6H8ZM6 8C4.89543 8 4 7.10457 4 6H2C2 8.20914 3.79086 10 6 10V8ZM4 6C4 4.89543 4.89543 4 6 4V2C3.79086 2 2 3.79086 2 6H4ZM6 4C7.10457 4 8 4.89543 8 6H10C10 3.79086 8.20914 2 6 2V4ZM7 21V9H5V21H7ZM5 9C5 11.6522 6.05357 14.1957 7.92893 16.0711L9.34315 14.6569C7.84285 13.1566 7 11.1217 7 9H5ZM7.92893 16.0711C9.8043 17.9464 12.3478 19 15 19V17C12.8783 17 10.8434 16.1571 9.34315 14.6569L7.92893 16.0711Z" }))));
};
exports.default = GitMerge;
